import { h, Component } from 'preact';
import style from './style.scss';
// import { changeLocale, changeLocaleLangs } from '../../../actions/user';

import { langPack } from '../../../utils/langPack';

class SearchInput extends Component {
  performSearch = () => {
    this.props.onSearch();
    firebase.analytics().logEvent('Tap_on_the_Search_bar')
  };

  changeHandler = (e) => {
    if (this.props.value !== e.target.value) {
      this.props.onChange(e.target.value);
    }
  }

  keyHandler = e => {
    if (e.keyCode === 13) {
      this.props.onSearch();
      firebase.analytics().logEvent('Tap_on_the_Search_bar');
    }
  }

  render({ value, placeholder, className = '' }) {
    return (
      <div className={`${className} ${style.searchContainer}`}>
        <input
          placeholder={placeholder || langPack[this.props.locale].SEARCH.ENTER_KEYWORDS}
          className={style.serchInput}
          value={value}
          onKeyUp={this.changeHandler}
          onKeyDown={this.keyHandler}
        />

        <span
          class={style.searchIcon}
          onClick={this.performSearch}
        />
      </div>
    )
  }
}

export default SearchInput;



// WEBPACK FOOTER //
// ./components/search/input/index.js